import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";

// Custom styling for Stripe Elements
const elementOptions = {
  style: {
    base: {
      fontSize: "16px",
      color: "#374151",
      fontFamily: "Inter, system-ui, sans-serif",
      "::placeholder": {
        color: "#9ca3af",
      },
    },
    invalid: {
      color: "#dc2626",
    },
  },
};

interface PaymentCardProps {
  stripeError: string | null;
}

export function PaymentCard({ stripeError }: PaymentCardProps) {
  return (
    <>
      <div className="mb-4">
        <div className="row g-3">
          <div className="col-12">
            <label className="form-label fw-semibold text-dark mb-2">
              Card Number
            </label>
            <div
              className="border-0 rounded-3 p-3"
              style={{
                backgroundColor: "#f8fafc",
                border: "1px solid #e2e8f0",
                transition: "all 0.2s ease",
              }}
            >
              <CardNumberElement options={elementOptions} />
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label fw-semibold text-dark mb-2">
              Expiry Date
            </label>
            <div
              className="border-0 rounded-3 p-3"
              style={{
                backgroundColor: "#f8fafc",
                border: "1px solid #e2e8f0",
                transition: "all 0.2s ease",
              }}
            >
              <CardExpiryElement options={elementOptions} />
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label fw-semibold text-dark mb-2">CVC</label>
            <div
              className="border-0 rounded-3 p-3"
              style={{
                backgroundColor: "#f8fafc",
                border: "1px solid #e2e8f0",
                transition: "all 0.2s ease",
              }}
            >
              <CardCvcElement options={elementOptions} />
            </div>
          </div>
        </div>
      </div>

      {/* Stripe Error Display */}
      {stripeError && (
        <div
          className="alert alert-danger mb-3 rounded-3 border-0"
          style={{ backgroundColor: "#fef2f2" }}
        >
          <div className="d-flex align-items-center gap-2">
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
            </svg>
            {stripeError}
          </div>
        </div>
      )}
    </>
  );
}
